<div fxLayout="column">
  <div fxLayout="row" fxLayoutAlign="start center center">
    <mat-icon *ngIf="icon" [ngStyle]="{'color': iconColor}">{{icon}}</mat-icon> &nbsp;
    <label style="font-weight: 700;">{{title}}</label>
  </div>
</div>
<mat-divider></mat-divider>
<mat-card class="mat-elevation-z0">
  <mat-card-content>
    <div class="cardContent">
      {{message}}
    </div>
  </mat-card-content>
  <mat-card-actions>
    <div fxLayout="column">
      <div fxLayout="row" fxLayoutAlign="end center center" class="cardContent">
        <button mat-flat-button color="primary" (click)="confirmDialog()">Ναι</button>
        <button mat-flat-button (click)="cancelDialog()">Άκυρο</button>
      </div>
    </div>
  </mat-card-actions>
</mat-card>
